import React from "react";
import { Linkedin } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { fileUrl } from "@/lib/api";

export default function Team({ team }) {
  if (!team || team.hidden) return null;
  const members = (team.members || []).filter((m) => !m.hidden);
  if (!members.length) return null;

  return (
    <section data-testid="team" className="bg-obsidian px-6 py-24 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <Eyebrow>{team.heading || "Our People"}</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-serif text-3xl leading-tight text-warmwhite lg:text-5xl">
            {team.subheading || "The desk behind the deals."}
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {members.map((m, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <div className="group h-full overflow-hidden border border-gold/15 bg-obsidian transition-all duration-500 hover:-translate-y-1 hover:border-gold/40" data-testid={`team-member-${i}`}>
                <div className="relative h-64 overflow-hidden bg-seablue/30">
                  {m.image ? (
                    <img src={fileUrl(m.image)} alt={m.name} className="h-full w-full object-cover opacity-90 transition-transform duration-700 group-hover:scale-105" />
                  ) : (
                    <div className="flex h-full w-full items-center justify-center font-serif text-5xl text-gold/30">{(m.name || "?").charAt(0)}</div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="font-serif text-xl text-warmwhite">{m.name}</h3>
                  <div className="mt-1 font-sans text-[11px] tracking-luxe uppercase text-gold">{m.role}</div>
                  {m.bio && <p className="mt-3 font-sans text-sm leading-relaxed text-softgrey">{m.bio}</p>}
                  {m.linkedin && <a href={m.linkedin} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-2 font-sans text-xs text-gold hover:underline"><Linkedin size={14} /> LinkedIn</a>}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
